import { Expose } from "class-transformer";
import { UserJobBase } from "domain/model/base";

export default class UserJob extends UserJobBase {
  @Expose({name: "job_name"})
  jobName?: string;
};
